<template>
    <div class="full-width" ref="hallSelectorDom" v-loading="loading">
      <el-row style="margin-bottom:20px; ">
        <el-button style="margin-left: 5px;"   :type="selctorType==0?'primary':'info'" tkey="前往3D" @click="clickGoChangeType(0)">{{i18n.tkey("lang_world_hall")}}</el-button>
        <el-button style="margin-left: 5px;"  :type="selctorType==1?'primary':'info'"  tkey="圓滿完成" @click="clickGoChangeType(1)" >{{i18n.tkey("lang_local_hall")}}</el-button>

      </el-row>

        <searchInput
            v-model="keyword"
            @change="changeKeyword"
        />

        <el-row :gutter="20" style="margin: 0">
            <el-col class="el-col-my" :span="contentSpan" v-for="(v, i) in recordList" :key="i + new Date().getTime()">
                <record14Preview :obj="v" @clickGo="clickGoBtn"  style="border: 1px solid #6c6969;"/>
            </el-col>
        </el-row>

        <paginationComponent :pageObj="pageObj" @goPage="goPage" />
    </div>
</template>

<script setup>
    import paginationComponent from "@/components/shopopee/common/paginationComponent"
    import record14Preview from "@/components/shopopee/hall/record14Preview"
    import searchInput from "@/components/shopopee/form/searchInput"
    import {Search} from '@element-plus/icons-vue';
    import {inject, ref, onMounted, getCurrentInstance} from "vue";
    import record14Api from "@/request/record14Api";
    import util from "@/util/util";

    const i18n = inject("i18n")

    const props = defineProps(["type"])
    const emits = defineEmits(["clickGo"])

    const { proxy } = getCurrentInstance()
    const loading = ref(false)
    const keyword = ref("")
    const contentSpan = ref(12)
    const width = ref(425)

    const recordList = ref([])
    const pageObj = ref({})
    const selctorType = ref(0)

    let pageNum = 1
    let pageSize = 10
    function clickGoChangeType(type) {
      selctorType.value = type
      keyword.value=""
      pageNum = 1
      getRecordList()
    }

    function getRecordList(){
        loading.value = true

        const request = record14Api.getRecord14InfoByPage
        const params = request.getParams()

        params.addinfo3 = util.formatDate(new Date(), 'yyyy/MM/dd')
        params.addinfo10 = selctorType.value
        params.recordname = keyword.value
        params.pageNum = pageNum
        params.pageSize = pageSize

        request.send(params, fillData)

    }

    function fillData(res){
        loading.value = false

        if (res.code == 200) {
            const obj = res.detail

            pageObj.value = obj
            recordList.value = obj.list

        }
    }

    function changeKeyword(){
        pageNum = 1
        getRecordList()
    }

    function clickGoBtn(obj){
        emits("clickGo", obj)
    }

    function goPage(num){
        pageNum = num

        getRecordList()
    }

    onMounted(() => {
        width.value = proxy.$refs.hallSelectorDom.offsetWidth

      if (null != props.type){
        selctorType.value = props.type
      }
        getRecordList()
    })

</script>

<style scoped>
    .full-width {
        width: 100%;
    }

    .el-col-my {
        margin-bottom: 15px;
    }

    .search-box {
        text-align: center;
        margin-bottom: 20px;
    }
</style>